import React, {useMemo} from 'react';
import {Circle, CircleMarker, MapContainer, Marker} from 'react-leaflet';
import {Icon} from 'leaflet';
import '../../../../../node_modules/leaflet/dist/leaflet.css';
import CustomTileLayer from '../../layout/map/CustomTileLayer.js';

const pointIcon = new Icon({
    iconUrl: '/images/marker-icon-green.png',
    iconSize: [28, 38],
    iconAnchor: [14, 38],
});

/**
 * Carte 150 px du rail : marqueur officiel du point + (exploitant) position de l'intervention
 * avec cercle de précision. `releve` null → pas de marqueur intervention (R6 / R7).
 */
function PointMap({point, releve, height = 150}) {
    const center = useMemo(() => {
        if (point?.latitude != null && point?.longitude != null) return [point.latitude, point.longitude];
        if (releve) return [releve.latitude, releve.longitude];
        return null;
    }, [point, releve]);

    if (!center) return null;

    return (
        <MapContainer center={center} zoom={17} scrollWheelZoom={false} zoomControl={false} dragging={false} attributionControl={false}
                      style={{height, width: '100%', borderRadius: 12}}>
            <CustomTileLayer/>
            {point?.latitude != null && <Marker position={[point.latitude, point.longitude]} icon={pointIcon}/>}
            {releve && (
                <>
                    {releve.accuracyM != null && (
                        <Circle center={[releve.latitude, releve.longitude]} radius={releve.accuracyM}
                                pathOptions={{color: '#0F2D69', fillColor: '#0F2D69', fillOpacity: 0.12, weight: 1}}/>
                    )}
                    <CircleMarker center={[releve.latitude, releve.longitude]} radius={6}
                                  pathOptions={{color: '#fff', fillColor: '#0F2D69', fillOpacity: 1, weight: 2}}/>
                </>
            )}
        </MapContainer>
    );
}

export default PointMap;
